import { ButtonRadioGroupField } from '@cian/components';
import * as React from 'react';

import { IJsonQuery } from '../../../json_query';
import { FOfferType, isCommercial, offerTypeFromJsonQuery } from '../../../utils/category';

const styles = require('./ObjectType.css');

export interface IObjectTypeStateProps {
  jsonQuery: IJsonQuery;
}

export interface IObjectTypeDispatchProps {
  onOfferTypeSelected(value: FOfferType): void;
  setDefaultSort(): void;
  clearRailwayTags(): void;
}

export type TObjectTypeProps = IObjectTypeStateProps & IObjectTypeDispatchProps;

enum EValues {
  Any = 'any',
  FlatOld = 'flatOld',
  FlatNew = 'flatNew',
}

const valueToOfferTypeMap = {
  [EValues.Any]: FOfferType.Flat,
  [EValues.FlatOld]: FOfferType.FlatOld,
  [EValues.FlatNew]: FOfferType.FlatNew,
};

const offerTypeToValueMap = {
  [FOfferType.Flat]: EValues.Any,
  [FOfferType.FlatOld]: EValues.FlatOld,
  [FOfferType.FlatNew]: EValues.FlatNew,
};

export class ObjectType extends React.Component<TObjectTypeProps> {
  public render() {
    const { jsonQuery } = this.props;
    const offerType = offerTypeFromJsonQuery(jsonQuery);

    return (
      <ButtonRadioGroupField
        value={offerTypeToValueMap[offerType]}
        onValueChange={this.handleObjectTypeSelection}
        buttonStyle={styles['button']}
        activeButtonStyle={styles['button--active']}
        values={[
          { value: EValues.Any, label: 'Все' },
          { value: EValues.FlatOld, label: 'Вторичка' },
          { value: EValues.FlatNew, label: 'Новостройка' },
        ]}
      />
    );
  }

  private handleObjectTypeSelection = (value: EValues) => {
    const offerType = valueToOfferTypeMap[value];
    /**
     * При выборе коммерческого типа объекта удаляем гео тэги поика по ЖД
     */
    if (isCommercial(offerType)) {
      this.props.clearRailwayTags();
    }

    this.props.onOfferTypeSelected(offerType);
    this.props.setDefaultSort();
  };
}
